<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <cmp-site-select
              ref="selectSIT"
              :pageId="this.$options.name"
              :selected="frame0.selectData.SIT"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="btn_wrap">
            <sui-button
              type="button"
              class="comm_btn_Reset"
              @click="onResetClick"
            >
              {{ $t("MSG_BTN_RESET") }}
            </sui-button>
            <sui-button
              v-permission:read="'PGE_CMY_00018'"
              type="button"
              class="comm_btn_Scr"
              @click="onSearchClick"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="comm_shut_wrap">
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4 class="comm_tit02">
              {{ $t("MSG_TXT_SITE") }}
            </h4>
          </div>
          <sui-grid
            ref="gridSite"
            :columns="gridColumns0"
            :dataset="'dataset0'"
            :enabletooltips="true"
            :showDisplayCountControl="false"
            :initialPagesize="10"
          />
        </div>
        <div class="btnbox" />
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4 class="comm_tit02">
              {{ $t("MSG_TXT_GBM") }}
            </h4>
          </div>
          <sui-grid
            ref="gridGbm"
            :columns="gridColumns1"
            :dataset="'dataset1'"
            :multiselect="true"
            :enabletooltips="true"
            :showDisplayCountControl="false"
            :initialPagesize="10"
          >
            <div class="comp_spacing" />
            <div class="btn_wrapL">
              <sui-button
                v-permission:create="this.$options.name"
                type="button"
                class="comm_btn_gridTop"
                @click="onAddClick"
              >
                {{ $t("MSG_BTN_ADD") }}
              </sui-button>
              <sui-button
                v-permission:delete="this.$options.name"
                type="button"
                class="comm_btn_gridTop"
                @click="onClickDelRow"
              >
                {{ $t("MSG_BTN_DEL") }}
              </sui-button>
            </div>
            <div class="btn_wrapR">
              <sui-button
                v-permission:download="'PGE_CMY_00018'"
                type="button"
                class="comm_btn_gridTop comm_ico_excel"
                @click="onDownloadExcel"
              >
                {{ $t("MSG_BTN_EXCEL_DOWN") }}
              </sui-button>
            </div>
          </sui-grid>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:update="'PGE_CMY_00018'"
          type="button"
          class="comm_btn_solid"
          @click="onSaveGbm"
        >
          {{ $t("MSG_BTN_SAVE") }}
        </sui-button>
        <sui-popup
          v-model="isShownPopupAdd"
          :title="$t('MSG_TIT_GBM_SELT')"
        >
          <p01
            :pageId="this.$options.name"
            @onAddClick="onAddClick"
            @close="popAddClose"
            @selected="onSelectedSiteInfo"
          />
        </sui-popup>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';
import p01 from './components/PGE_CMY_00018_P01';

const dateTypeFields = ['firstRegistrationDTM', 'finalModificationDTM'];

export default {
  name: 'PGE_CMY_00018', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
  },
  extends: BasePage,
  data() {
    return {
      pageName: 'PGE_CMY_00018',
      codes: CommonConstants.selectOptions(),
      frame0: {
        selectData: {
          // Codes
          SIT: {
            key: '',
            label: '',
          },
        },
      },
      selectSiteId: '',
      isShownPopupAdd: false,
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_GNRZ_AREA'),
        datafield: 'gnrzAreaName',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_SITE_ID'),
        datafield: 'siteId',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_SITE_ABBR'),
        datafield: 'siteAbbName',
      }],
      localdata1: [],
      localdata2: [],
      gridColumns1: [{
        text: this.$t('MSG_TXT_SITE_ID'),
        datafield: 'siteId',
        hidden: true,
      }, {
        text: this.$t('MSG_TXT_GBM_CD'),
        datafield: 'gbmCode',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_GBM_NM'),
        datafield: 'gbmName',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'finalModificationUserId',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
          }, this.dataset1, this.$refs.gridGbm);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: '150px',
      }],
      gridColumns2: [{
        text: 'No.',
        datafield: 'dataset-row-id',
      }, {
        text: this.$t('MSG_TXT_GNRZ_AREA'),
        datafield: 'gnrzAreaName',
      }, {
        text: this.$t('MSG_TXT_SITE_ID'),
        datafield: 'siteId',
      }, {
        text: this.$t('MSG_TXT_SITE_ABBR'),
        datafield: 'siteAbbName',
      }, {
        text: this.$t('MSG_TXT_GBM_CD'),
        datafield: 'gbmCode',
      }, {
        text: this.$t('MSG_TXT_GBM_NM'),
        datafield: 'gbmName',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'userName',
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'gnrzAreaName',
      type: 'string',
      map: 'gnrzAreaName',
    }, {
      name: 'siteId',
      type: 'string',
      map: 'siteId',
    }, {
      name: 'siteAbbName',
      type: 'string',
      map: 'siteAbbName',
    }],
  }, {
    id: 'dataset1',
    type: 'local',
    data: 'localdata1',
    datafields: [{
      name: 'dataset-row-id',
      type: 'string',
      map: 'dataset-row-id',
    }, {
      name: 'siteId',
      type: 'string',
      map: 'siteId',
    }, {
      name: 'gbmCode',
      type: 'string',
      map: 'gbmCode',
    }, {
      name: 'gbmName',
      type: 'string',
      map: 'gbmName',
    }, {
      name: 'finalModificationUserId',
      type: 'string',
      map: 'finalModificationUserId',
    }, {
      name: 'finalModificationDTM',
      type: 'string',
      map: 'finalModificationDTM',
    }, {
      name: 'rowType',
      type: 'string',
      map: 'rowType',
    }, {
      name: 'displayLanguageId',
      type: 'string',
      map: 'displayLanguageId',
    }, {
      name: 'knoxId',
      type: 'string',
      map: 'knoxId',
    }, {
      name: 'userName',
      type: 'string',
      map: 'userName',
    }, {
      name: 'userGlobalName',
      type: 'string',
      map: 'userGlobalName',
    }, {
      name: 'departmentName',
      type: 'string',
      map: 'departmentName',
    }, {
      name: 'departmentEnglishName',
      type: 'string',
      map: 'departmentEnglishName',
    }],
  }, {
    id: 'dataset2',
    type: 'local',
    data: 'localdata2',
    datafields: [{
      name: 'dataset-row-id',
      type: 'string',
      map: 'dataset-row-id',
    }, {
      name: 'siteId',
      type: 'string',
      map: 'siteId',
    }, {
      name: 'gbmCode',
      type: 'string',
      map: 'gbmCode',
    }, {
      name: 'gbmName',
      type: 'string',
      map: 'gbmName',
    }, {
      name: 'finalModificationUserId',
      type: 'string',
      map: 'finalModificationUserId',
    }, {
      name: 'finalModificationDTM',
      type: 'string',
      map: 'finalModificationDTM',
    }, {
      name: 'rowType',
      type: 'string',
      map: 'rowType',
    }],
  }],
  mounted() {
    this.dataset0.$on(this.dataset0.EVENTS.SELECTION_CHANGED, this.onselectGrid);
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {
    // this.dataset0.$off(this.dataset0.EVENTS.SELECTION_CHANGED, this.onselectGrid);
  },
  methods: {
    onSearchClick() {
      const codeValue = this.frame0.selectData;
      const queryParams = {
        searchSiteCode: utils.trim(codeValue.SIT.key) || '',
      };
      queryParams.searchSiteCode = queryParams.searchSiteCode === 'ALL' ? '' : queryParams.searchSiteCode;

      http.request(this.$options.name, 'DTS_CMY_00021', {
        query: queryParams,
      }).then(res => {
        this.localdata0 = res.data;
        this.dataset0.setRawData(this.localdata0);

        if (this.dataset0.data.length > 0) {
          this.dataset0.clearSelection();
          this.dataset0.setSelectedIndex([0]);
        } else {
          this.dataset0.clearSelection();
        }
        this.dataset1.setRawData([]);
      }).catch(error => {
        console.log(error);
      });
    },
    onResetClick() {
      this.$refs.selectSIT.reset();
    },
    onAddClick() {
      const selectedIndexes = this.dataset0.getSelectedIndexes();

      if (selectedIndexes.length < 1) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SITE_ID'));
        return false;
      }

      // this.selectSiteId = this.dataset0.data[selectedIndexes].siteId;

      // if (this.selectSiteId !== '') {
      //   this.isShownPopupAdd = !this.isShownPopupAdd;
      // }

      this.isShownPopupAdd = !this.isShownPopupAdd;
      return true;
    },
    popAddClose() {
      this.isShownPopupAdd = !this.isShownPopupAdd;
      // this.onSearchClick();
    },
    onClickDelRow() {
      // const selectedRows = [];
      this.dataset2.setRawData([]);
      const deleteRows = [];
      const selectedSiteIndexes = this.dataset0.getSelectedIndexes();
      const selectedGbmIndexes = this.dataset1.getSelectedIndexes();

      if (selectedSiteIndexes.length < 1) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SITE_ID'));
        return;
      }

      if (selectedGbmIndexes.length === 0) {
        utils.messageBox('warning', this.$t('MSG_ALT_DEL_DATA_SELT'));
        return;
      }

      utils.forEach(selectedGbmIndexes, index => {
        // selectedRows.push(this.dsFileLst.data[index]);

        if (utils.isEmpty(this.dataset1.data[index].rowType)) {
          deleteRows.push(this.dataset1.data[index]);
        }
      });

      this.dataset1.deleteRows(selectedGbmIndexes);
      this.dataset2.addRows(deleteRows);
      // this.dataset1.setSelectedIndexes([]);
    },
    onselectGrid(data) {
      const selectedIndexes = this.dataset0.getSelectedIndexes();
      let selSiteId = '';

      if (selectedIndexes.length < 1) {
        return;
      }

      selSiteId = this.dataset0.data[data.newSelections].siteId;
      http.request(this.$options.name, 'DTS_CMY_00022', {
        path: {
          'site-id': selSiteId,
        },
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);

        this.dataset1.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      }).catch(error => {
        console.log(error);
      });
    },
    onDownloadExcel() {
      const metaObj = {
        // "headerTitle" : {
        //   "codeName" : this.$t('MSG_TXT_CODE_NAME'),
        //   "codeEngName" : this.$t('MSG_TXT_CODE_ENAME'),
        //   "codeAbb" : this.$t('MSG_TXT_ABBR'),
        // },
        headerFontSize: 16,
        headerFontColor: 1,
        headerForegroundColor: 22,
      };

      const sPageId = this.$options.name;
      const objGridColumns = this.gridColumns2;
      const objGridDataset = this.dataset1;
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `gbm-list_${sToday}.xlsx`;

      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, metaObj);
    },
    onSelectedSiteInfo(site) {
      const addNewRows = [];

      utils.forEach(site, obj => {
        const defaultRow = {
          rowType: 'I',
          gbmCode: obj.gbmCode,
          gbmName: obj.gbmName,
        };

        // 중복 체크
        if (utils.findIndex(this.dataset1.getRawData(), ['gbmCode', defaultRow.gbmCode]) === -1) {
          addNewRows.push(defaultRow);
        }
      });
      this.dataset1.addRows(addNewRows);

      // this.dataset1.setSelectedIndexes([]);
    },
    onSaveGbm() {
      const selectedIndexes = this.dataset0.getSelectedIndexes();
      const deleteIndexes = this.dataset2.getSelectedIndexes();

      if (selectedIndexes.length === 0 && deleteIndexes.length === 0) {
        return;
      }

      const gridParams = {
        siteId: this.dataset0.data[selectedIndexes].siteId,
        gbmList: this.dataset1.data,
        gbmDelList: this.dataset2.data,
      };

      // if (this.dataset1.data.length === 0) {
      //   return;
      // }

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        console.log(this.$options.name);
        http.request(this.$options.name, 'DTS_CMY_00024', {
          data: gridParams,
        }).then(() => {
          this.dataset1.setRawData([]);
          this.dataset2.setRawData([]);
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, this.research);
        }).catch(error => {
          console.log(error);
        });
        // }
      });
    },
    research() {
      const selectedIndexes = this.dataset0.getSelectedIndexes();
      let selSiteId = '';

      if (selectedIndexes.length < 1) {
        return;
      }

      selSiteId = this.dataset0.data[selectedIndexes].siteId;
      http.request(this.$options.name, 'DTS_CMY_00022', {
        path: {
          'site-id': selSiteId,
        },
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);

        this.dataset1.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
        this.dataset0.clearSelection();
        this.dataset1.clearSelection();
      }).catch(error => {
        console.log(error);
      });
    },
  },
};
</script>
<style scoped>
</style>
